module.exports = __webpack_public_path__ + "img/2.d3dec82d.jpg";